import React from 'react';
import '../../IntegrationBaseComponent.scss';
import css from './FacebookAdsIntegrations.module.css';
import Select from 'antd/es/select';

import {
  ButtonColor,
  PrimaryButton,
} from '../../../../../../../../common/buttons/PrimaryButton/PrimaryButton';
import { useConnectionsTableActions } from '@mm/state/modules/connectionsTableState/actions';
import { LinkOutlined } from '@ant-design/icons';
import { useViewActions } from '@mm/state/actions/viewActions';
import { useAdAccount } from './use-ad-account';
import AdAccountModel from '@mm/state/model/AdAccountModel';
import { Alert } from '@mm/components';
import { TooltipGuard } from '../../../../../../../../modules/permissions/RequiresPermissions';

type Props = {
  count: number;
  onConnectAccountClick?: () => void;
  className?: string;
  name?: string;
};

export const FacebookAdsIntegrationsHeader = (props: Props) => {
  const adAccount = useAdAccount();

  const { count, name } = props;

  const { setActiveIntegration } = useConnectionsTableActions();

  const { showSlideoutMenu } = useViewActions();

  const addNew = async () => {
    showSlideoutMenu('fbAdsIntegrationEditor');
  };

  const onClickAddNew = () => {
    addNew();
    setActiveIntegration(name);
  };

  const onPageConnectSuccess = () => adAccount.fetchAccounts();

  return (
    <TooltipGuard
      position="top"
      classNameArrow={css.arrow}
      onPageConnectSuccess={onPageConnectSuccess}
    >
      {isAllowed => (
        <div className="integrations__header-actions">
          {!adAccount?.activeAdAccount && (
            <div className={css.notConnected}>
              <Alert type="warning" className={css.alert} showCloseIcon={false}>
                Facebook ad account is not selected
              </Alert>

              <Select<string | undefined, AdAccountModel>
                disabled={!isAllowed}
                placeholder="Choose ad account"
                options={adAccount.adAccounts.map(v => ({
                  value: v.id,
                  label: adAccount.renderAdAccountName(v),
                  ...v,
                }))}
                onClick={e => {
                  e.stopPropagation();
                }}
                value={adAccount?.activeAdAccount?.id}
                onChange={(v, opt) => {
                  adAccount.changeAccount(opt as AdAccountModel);
                }}
              />
            </div>
          )}
          {!!adAccount?.activeAdAccount && (
            <>
              <div className="integrations__header-status">
                Synced Audiences
                <LinkOutlined className="integrations__header-status-icon" />
                <div className="integrations__header-status-count">{count}</div>
              </div>
              <PrimaryButton
                disabled={!isAllowed}
                className="integrations__header-add-button-secondary"
                onClick={e => {
                  e?.stopPropagation();
                  onClickAddNew();
                }}
                color={ButtonColor.secondaryBlue}
              >
                Create Facebook audience
              </PrimaryButton>
            </>
          )}
        </div>
      )}
    </TooltipGuard>
  );
};
